<template>
	<v-sheet :loading="loading">
		<p>
			총 참여 개월 {{ stamp_list.length }} / 총 당첨 횟수
			{{ winner_count }}
		</p>
		<p>
			이벤트 진행 월
			<select v-model="selected_stamp_id" @change="load" class="ml-1">
				<option
					v-for="stamp in stamp_list"
					:key="stamp.stamp_id"
					:value="stamp.stamp_id"
				>
					{{ stamp.calendar_on }}
				</option>
			</select>

			<span class="ml-3"
				>당첨 여부:
				{{
					(selected_stamp && selected_stamp.win_title) || '없음'
				}}</span
			>
		</p>

		<table class="list">
			<tr>
				<th width="100">참여일</th>
				<th width="100">일반출석일시</th>
				<th width="100">리뷰미션일시</th>
				<th width="120">리뷰카테고리</th>
				<th width="200">리뷰브랜드</th>
				<th width="*">리뷰제품</th>
				<th width="80">댓글</th>
				<th width="100">강제출석처리</th>
				<th width="100">처리자</th>
				<th width="100">처리일시</th>
			</tr>

			<tr v-for="date in getTargetDates()" :key="date">
				<td>{{ date }}</td>
				<td>
					<template
						v-if="
							daily_stamps[date] &&
							!daily_stamps[date].review_date.length
						"
					>
						{{
							Util.dateFormat(
								daily_stamps[date].stamped_at,
								'MM-DD HH:mm'
							)
						}}
					</template>
				</td>
				<td>
					<template
						v-if="
							daily_stamps[date] &&
							daily_stamps[date].review_date.length
						"
					>
						<template
							v-for="(review_date, idx) in daily_stamps[date]
								.review_date"
						>
							<p
								:key="idx"
								v-if="
									idx + 1 ===
									daily_stamps[date].review_date.length
								"
								:style="{ marginBottom: 0 }"
							>
								{{
									moment
										.utc(review_date)
										.format('MM-DD HH:mm')
								}}
								<v-menu
									v-if="
										daily_stamps[date].review_date.length >
										1
									"
									offset-y
									open-on-hover
								>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											small
											color="error"
											depressed
											text
											v-bind="attrs"
											v-on="on"
											v-text="'**중복미션**'"
										/>
									</template>
									<v-simple-table>
										<template v-slot:default>
											<tbody>
												<tr
													v-for="(
														item, idx
													) in daily_stamps[date]
														.reviewList"
													:key="idx"
												>
													<td>
														{{
															moment
																.utc(
																	item.created_at
																)
																.format(
																	'MM-DD HH:mm'
																)
														}}
													</td>
													<td>
														{{
															item.category_title
														}}
													</td>
													<td>
														{{ item.brandTitle }}
													</td>
													<td>
														{{ item.productTitle }}
													</td>
												</tr>
											</tbody>
										</template>
									</v-simple-table>
								</v-menu>
							</p>
						</template>
					</template>
				</td>
				<td>{{ _.get(daily_stamps[date], 'category_title') }}</td>
				<td>{{ _.get(daily_stamps[date], 'brandTitle') }}</td>
				<td>
					<router-link
						v-if="daily_stamps[date]"
						:to="`/review/${daily_stamps[date].review_id}`"
						target="_blank"
						>{{ daily_stamps[date].productTitle }}</router-link
					>
				</td>
				<td>
					<button
						:disabled="!_.get(daily_stamps[date], 'commentCnt')"
						class="btn"
						v-text="_.get(daily_stamps[date], 'commentCnt', 0)"
						@click="openCommentDialog(date)"
					/>
				</td>
				<td>
					<v-btn
						v-if="canForceStamp(date)"
						@click="forceStamp(date)"
						color="error"
						x-small
						:disabled="!!selected_stamp.select_on"
						>출석 처리</v-btn
					>
					<span
						v-else-if="daily_stamps[date].is_force_stamp"
						class="red--text"
						>강제 출석</span
					>
				</td>
				<td>{{ _.get(daily_stamps[date], 'admin_nickName') }}</td>
				<td>
					<template
						v-if="
							_.get(daily_stamps[date], 'admin_nickName') &&
							_.get(daily_stamps[date], 'created_at')
						"
					>
						{{
							Util.dateFormat(
								daily_stamps[date].created_at,
								'MM-DD HH:mm'
							)
						}}
					</template>
				</td>
			</tr>
		</table>
	</v-sheet>
</template>

<script>
	import _ from 'lodash';
	import moment from 'moment';
	import Util from '@/lib/Util';

	export default {
		data() {
			return {
				loading: false,
				register_id: this.$route.params.idRegister,
				counter: {},
				stamp_list: [],
				daily_stamps: {},
				selected_stamp_id: undefined,
				moment,
			};
		},

		computed: {
			winner_count() {
				return _.filter(this.stamp_list, { is_win: 1 }).length;
			},
			selected_stamp() {
				return _.find(this.stamp_list, {
					stamp_id: this.selected_stamp_id,
				});
			},
		},

		created() {},

		async mounted() {
			await this.load();
			// 출석체크 선택된 뒤 한번 더 호출
			await this.load();
		},

		methods: {
			async load() {
				try {
					this.loading = true;
					const params = { stamp_id: this.selected_stamp_id };
					const { data } = await this.$axiosAdmin2.get(
						`/v3/api/stamp/register-detail/${this.register_id}`,
						{ params }
					);
					this.counter = data.attendanceAndWinCount[0];
					this.stamp_list = data.attendanceAndWin;
					this.daily_stamps =
						data.register_stamp_daily?.reduce((acc, cur) => {
							const key = moment(cur.stamped_at).format(
								'YYYY-MM-DD'
							);
							const reviewDate = acc[key]?.review_date;
							const curReviewDate = cur.review_date;
							if (reviewDate && curReviewDate) {
								acc[key].review_date = [
									...reviewDate,
									curReviewDate,
								];
								acc[key].reviewList.push({
									created_at: cur.created_at,
									category_title: cur.category_title,
									brandTitle: cur.brandTitle,
									productTitle: cur.productTitle,
								});
							} else {
								acc[key] = cur;
								acc[key].review_date = _.compact([
									curReviewDate,
								]);
								if (acc[key].review_date.length) {
									acc[key].reviewList = [
										{
											created_at: cur.created_at,
											category_title: cur.category_title,
											brandTitle: cur.brandTitle,
											productTitle: cur.productTitle,
										},
									];
								}
							}
							return acc;
						}, {}) || {};
					if (!this.selected_stamp_id) {
						this.selected_stamp_id = _.get(
							this.stamp_list,
							'0.stamp_id'
						);
					}
				} catch (e) {
					Util.error(e);
				} finally {
					this.loading = false;
				}
			},

			getTargetDates() {
				if (!this.selected_stamp_id) return [];
				const dates = [];
				const current = moment(
					_.find(this.stamp_list, {
						stamp_id: this.selected_stamp_id,
					}).calendar_on
				).endOf('month');
				const day = current.daysInMonth();

				for (let offset = 0; offset < day; offset++) {
					const date = moment(current)
						.add(-offset, 'd')
						.format('YYYY-MM-DD');
					if (date <= moment().format('YYYY-MM-DD')) {
						dates.push(date);
					}
				}
				return dates;
			},

			canForceStamp(date) {
				const stamp = this.daily_stamps[date];
				return !stamp || (!stamp.stamped_at && !stamp.review_date);
			},

			async forceStamp(date) {
				this.loading = true;
				try {
					await this.$axiosAdmin2.post(
						`/v3/api/stamp/${this.selected_stamp_id}/register/${this.register_id}/${date}`
					);
					await this.load();
				} catch (e) {
					console.error(e);
					alert(e);
				} finally {
					this.loading = false;
				}
			},

			openCommentDialog(date) {
				this.$store.commit('modal/toggleModal', {
					id: 'StampCommentList',
					params: {
						idStamp: this.selected_stamp_id,
						idRegister: this.register_id,
						date,
					},
				});
			},
		},
	};
</script>
